import { render, staticRenderFns } from "./myComment.vue?vue&type=template&id=120f5507&"
import script from "./myComment.vue?vue&type=script&lang=js&"
export * from "./myComment.vue?vue&type=script&lang=js&"
import style0 from "./myComment.vue?vue&type=style&index=0&lang=less&soced=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports